import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'

interface UseUpdatePublicCompanyLeadContractFile {
  publicCompanyLeadId?: string
  onSuccess?: (response: any) => void
  onError?: (error: any) => void
}

export const useUpdatePublicCompanyLeadContractFile = ({
  publicCompanyLeadId,
  onSuccess,
  onError,
}: UseUpdatePublicCompanyLeadContractFile) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['updatePublicCompanyLeadContractFile'],
    mutationFn: async (file: Blob) => {
      const lead = {
        contract_attributes: {
          file,
        },
      }

      await privateAxios.putForm(`/funnel/public/leads/${publicCompanyLeadId}`, {
        lead,
      })
    },
    onSuccess,
    onError,
  })
}
